import { DateTime } from 'luxon';
import getRoundedToNearestHour from '../time/getRoundedToNearestHour';

const formatMillisToDate = (millis: number) =>
  DateTime.fromMillis(getRoundedToNearestHour(millis)).toFormat('d MMM');

const formatMillisToTime = (millis: number) =>
  DateTime.fromMillis(getRoundedToNearestHour(millis)).toFormat('HH:mm');

const getFormattedMillisFromInterval = (
  millisLower: number,
  millisUpper: number,
  millis: number,
): string =>
  millisUpper - millisLower >= 90000000 ? formatMillisToDate(millis) : formatMillisToTime(millis);

export default getFormattedMillisFromInterval;
